import axios from "./config";
import { getHeader, getUserInfo } from "../utility/index";

interface ApiResponse {
  data: any;
}

const getLeaderBoardList = async (
  param: any,
  data: any
): Promise<ApiResponse> => {
  const user_info = getUserInfo();
  const response = await axios.post<ApiResponse>(
    `/supervisors/${user_info.emp_id}/leaderboard`,
    data,
    {
      params: param,
      headers: getHeader(),
    }
  );
  return response;
};

const getDashboardKpiData = async (data: any): Promise<ApiResponse> => {
  const user_info = getUserInfo();
  console.log(user_info)

  const response = await axios.post<ApiResponse>(
    `/supervisors/${user_info.emp_id}/dashboard`,
    data,
    {
      headers: getHeader(),
    }
  );
  return response;
};

const getDashboardMatrics = async (param: any): Promise<ApiResponse> => {
  const user_info = getUserInfo();
  const response = await axios.get<ApiResponse>(
    `/supervisors/${user_info.emp_id}/dashboard-metrics`,
    {
      headers: getHeader(),
      params: param,
    }
  );
  return response;
};
const fetchDashboardDataa = async (data: any): Promise<ApiResponse> => {
  const user_info = getUserInfo();
  const response = await axios.post<ApiResponse>(
    `/supervisors/${user_info.emp_id}/dashboard-data`,
    data,
    {
      headers: getHeader(),
    }
  );
  return response;
};

const getAnalyticsMatrics = async (param: any): Promise<ApiResponse> => {
  const user_info = getUserInfo();
  const response = await axios.post<ApiResponse>(
    `/supervisors/${user_info.emp_id}/subordinates/targets`,param,
    {
      headers: getHeader(),
    }
  );
  return response;
};
const getB2BMatrics = async (param: any): Promise<ApiResponse> => {
  const user_info = getUserInfo();
  const response = await axios.post<ApiResponse>(
    `/b2b/${user_info.emp_id}/dashboard`,param,
    {
      headers: getHeader(),
    }
  );
  return response;
};

export default getLeaderBoardList;
export { getDashboardMatrics, getDashboardKpiData , getAnalyticsMatrics,getB2BMatrics,fetchDashboardDataa};
